var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-client-table',{attrs:{"data":_vm.facesImpactees,"columns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"dateDebutAff",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.func.formatDate(row.dateDebutAff))+" ")]}},{key:"dateFinAff",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.func.formatDate(row.dateFinAff))+" ")]}},{key:"adresse",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.func.adressFullStringGetter(row.adresse, true))+" ")]}},{key:"codePostal",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.adresse.codePostal)+" ")]}},{key:"ville",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.adresse.ville)+" ")]}},{key:"typeModification",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.isDeleted ? _vm.$t('catalogue.popUpCheckFacesImpact.typeModification.suppression') : _vm.$t('catalogue.popUpCheckFacesImpact.typeModification.modification'))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }